<template>
  <ComponentsLayoutWithNavbar
    id="catalog"
    main_color="main__light_green"
    no-scroll
    no-wrap
    with_footer>
    <template #breadcrumbs>
      <TenderBreadcrumbs
        v-if="mode == 'tender'"
        :check-exit="checkChages"
        without_top_padding/>
      <NewPurchBread
        v-else
        class="pt-0"/>
    </template>
    <template #main_content>
      <div
        class="content-card catalog px-0 main__light_green">
        <div class="flex flex-between">
          <div>
            <slot name="step_number"/>
            <div class=" h1-headline">
              {{ title }}
            </div>
          </div>
          <div
            v-if="(tender || $can('add', 'appResources')) && !(tender && tender.biddingType.onlyOneLotPerTender)"
            class="mt-auto mb-0 ml-auto">
            <ImportXLS
              v-if="tender"
              :disabled="imported && cart && !!cart.length"
              :tender="tender"
              @onSubmit="updateCart"
              @onSubmitTender="$emit('updateTender', $event)"/>
            <InDevelopmentInfo
              v-else-if="$can('add', 'appResources')"
              condition
              prevent>
              <template #activator>
                <ImportXLS btn_class="mx-0"/>
              </template>
            </InDevelopmentInfo>
          </div>
        </div>
        <div class="pt-6">
          <slot name="search_bar"/>
        </div>
        <div class="pt-5">
          <div class="directory-name px-1">
            {{ $t('Catalog.DirectoryOfGoods') }}
          </div>
          <sDivider/>

          <div
            v-if="loading === true"
            class=" pt-4 main__light_green">
            <div
              v-for="(item, n) in load_skeleton_array"
              :key="n"
              class="main__light_green ">
              <v-skeleton-loader
                ref="skeleton"
                :boilerplate="false"
                class="main__green--text"
                :tile="false"
                type="sentences"
                width="70%"/>
            </div>
          </div>
          <template v-else>
            <slot name="treeview"/>
          </template>
        </div>
      </div>
    </template>
    <template #nav_bar="{ mini }">
      <div
        class="new-purchase-items pt-10 main__green text-left px-4">
        <template v-if="!mini && load_app">
          <v-skeleton-loader
            class=" px-8"
            height="50px"
            type="heading"
            width="80%"/>
          <v-skeleton-loader
            v-for="(i, n) in new Array(3)"
            :key="n"
            class="mt-3 px-8"
            height="50px"
            type="sentences"
            width="100%"/>
        </template>
        <div
          v-else-if="!mini && (!cart || (cart && cart.length == 0))"
          class="px-2 nav-card main__green"
          elevation="0">
          <div class="no-rows-title mb-4">
            {{ $t('Catalog.NoRowsTitle') }}
          </div>
          <div class="no-rows-text">
            {{ $t('Catalog.NoRowsText') }}
          </div>
          <sIcon
            v-if="loading == 'select'"
            color="var(--secondary__green_not_active)"
            size="30"
            spin
            type="loading"/>
        </div>
        <div
          v-else-if="!mini"
          class="px-2 nav-card main__green"
          elevation="0">
          <div class="flex no-rows-title py-2 px-2 flex-between">
            <span>{{ $t('Catalog.Added') }} {{ cart ? cart.length : 0 }}</span>
            <sIcon
              v-if="loading == 'select'"
              color="var(--secondary__green_not_active)"
              size="20"
              spin
              type="loading"/>
            <slot name="clear_cart"/>
          </div>
          <slot name="cart_list"/>
        </div>
      </div>
    </template>
    <template #footer>
      <slot name="footer"/>
    </template>
  </ComponentsLayoutWithNavbar>
</template>
<script>
import ImportXLS from 'components/tenders/dialogs/ImportXLS/ImportXLS.vue'
import TenderBreadcrumbs from 'components/tenders/TenderBreadcrumbs.vue'
import InDevelopmentInfo from 'components/common/elements/InDevelopmentInfo.vue'
import NewPurchBread from 'components/purchasing/new purchase/NewPurchBread.vue'
import ComponentsLayoutWithNavbar from 'pages/templates/ComponentsLayoutWithNavbar.vue'

export default {
  name: 'catalogComponent',
  props: {
    mode: String,
    application: Object,
    tender: Object,
    dialog: Boolean,
    disabled_next_btn: Boolean,
    cart: {
      type: Array,
      default: () => { [] }
    },
    loading: [Boolean, String],
    load_app: [Boolean, String],
    search_text: String,
    title: String,
    nextStep: Function,
    checkChages: Function,
    next_loading: Boolean,
    validate: Function,
    noWrap: {
      type: Boolean
    }
  },
  data() {
    return {
      timeout: 0,
      count: 0,
      opened: [],
      groups: [],
      search: null,
      searched: [],
      selected_positions: [],
      page: 1,
      selected_id: [],
      imported: false,
      load_skeleton_array: new Array(9)
    }
  },
  computed: {
    open: {
      get() {
        return this.dialog
      },
      set(val) {
        this.$emit('update:dialog', val)
      }
    },
    rmdClientPath: {
      get() {
        return window.config.rmdClientUrl + '/Ticket/Set'
      }
    },
  },
  methods: {
    updateCart(data) {
      if (this.mode == 'tender') {
        this.$emit('importLots', data)
      } else {
        this.$store.commit('setCartItems', this.cart)
      }

      if ( !data?.length ) {
        return
      }
      this.imported = true
    },
  },
  watch: {
    search(val) {
      this.$emit('searching', val)
    }
  },
  components: {
    ImportXLS,
    NewPurchBread,
    InDevelopmentInfo,
    TenderBreadcrumbs,
    ComponentsLayoutWithNavbar
  }
}
</script>
<style lang="scss" scoped>
.tree-item {
  white-space: normal;
  line-height: 20px;
}
.content-card {
  width: 100%;
  .v-card__title {
    span {
      font-weight: 500;
      font-size: 32px;
    }
    .v-subheader:first-child {
      color: #A0A4A8;
    }
  }
  .card-title-text {
    line-height: 20px;
    font-size: 16px;
    color: var(--text-color);
  }
  .directory-name {
    font-weight: 500;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: 0.01em;
        color: rgba(var(--black-color-rgba), .6);
        padding: 0 16px 0 16px;
        display: flex;
        align-items: center;
  }
  .children-count{
    height: 15px;
    background: var(--black-color);
    color: var(--white-color);
    border-radius: 6px;
    font-weight: 500;
    font-size: 10px;
    line-height: 15px;
    vertical-align: middle;
  }
}

.sticky {
  z-index: 6;
  position: sticky;
}
.new-purchase-items {
  height: 100%;
  width: 100%;
  align-items: end;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;

  .nav-card{
  width: 100%;

  }
  .nav-actions {
    // position: absolute;
    height: 80px;
    max-height: 83px;
    bottom: 0;
    width: 100%;
    background-color: var(--white-color);
    z-index: 20;
  }
  .no-rows-text  {
    font-size: 16px;
    line-height: 20px;
    color: var(--text-color);
    text-align: start;
  }
  .no-rows-title {
    font-size: 17px;
    line-height: 20px;
    font-weight: 500;
    .btn {
      font-weight: 500;
      font-size: 11px;
      letter-spacing: 0.02em;
    }
  }
}
</style>
<style lang="scss">
.content-card.catalog {
  .v-skeleton-loader .v-skeleton-loader__text.v-skeleton-loader__bone{
    background-color: var(--v-main__green-base);
  }
  .v-card__text {
    height: calc(100vh - 320px);
    .v-treeview {
      max-height: calc(100% - 0px);
      overflow: auto;
    }
  }
  .v-treeview-node.v-treeview-node--click[aria-expanded=true] > .v-treeview-node__root:first-child, .v-treeview-node__root:hover {
    background-color: var(--v-secondary__green_chosen-base);
  }
  .v-treeview-node__root {
    border-bottom: 1px solid var(--v-main__green-base);
    &::before {
      opacity: 0 !important;
    }
  }
  .v-treeview-node__toggle,
  .v-treeview-node__root:last-child .v-treeview-node__root:first-child,
  .v-treeview-node--leaf .v-treeview-node__level:first-child {
    display: none
  }
  //  {

  // }
  .v-treeview-node__label{
    text-align: start;
  }

  .v-treeview-node__children .v-treeview-node__root {
    min-height: 52px;

  }
  div[aria-expanded=false]{
    width: 100%;
    line-height: 52px;
  }
}

</style>
